import { render, staticRenderFns } from "./mxik.vue?vue&type=template&id=5896fe67&scoped=true"
import script from "./mxik.vue?vue&type=script&lang=js"
export * from "./mxik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896fe67",
  null
  
)

export default component.exports